import React, { createContext, useContext, ReactNode } from 'react';
interface ObjectType {
  [key: string]: number;
}
interface Insight {

  baby_users_quantity: number;
  booking_clicks: number;
  content_article_read: number;
  content_video_play: number;
  content_view_quantity: number;
  curiosity_share: number;
  exam_view_quantity: number;
  frame_share_quantity: number;
  insight_date: string;
  live_view_quantity: number;
  logo_share: number;
  most_popular_baby_name: ObjectType | null
  most_shared_frame: ObjectType | null
  most_viewed_content_type: [] | null
  organization_code: string;
  top_viewed_content: ObjectType | null
  total_exams: number;
}

export interface InsightsData {
  logo_url: string;
  organization: string;
  frame_url: string | null,
  insight: Insight,
  feedbacks: [] | null,
  insight_list: [],
}

interface InsightsDataContextValue {
  insightsData: InsightsData | undefined;
  setInsightsData: (data: InsightsData) => void;
}

const InsightsDataContext = createContext<InsightsDataContextValue | undefined>(undefined);

export function InsightsDataProvider({ children }: { children: ReactNode }) {
  const [insightsData, setInsightsData] = React.useState<InsightsData | undefined>(undefined);
  return (
    <InsightsDataContext.Provider value={{ insightsData, setInsightsData }}>
      {children}
    </InsightsDataContext.Provider>
  );
}

export function useInsightsData() {
  const context = useContext(InsightsDataContext);
  if (!context) {
    throw new Error('useInsightsData deve ser usado dentro de um InsightsDataProvider');
  }
  return context;
}
